<template>
  <div class="marcaProducto">
    <label for="marcaProducto">Marca Producto</label>
    <select name="marcaProducto" v-model="marcaProducto" class="pointer" id="marcaProducto">
      <option value="">Seleccione...</option>
      <option v-for="item in marcas" :value="item">{{item.nombre | upper}}</option>
    </select>
    <i class="bar"></i>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "MarcaProducto",
    created() {
      this.$store.dispatch("producto/getMarcaProducto")
    },
    computed: {
      ...mapGetters({
        marcas: "producto/marcasProducto"
      }),
      marcaProducto: {
        get() {
          return this.$store.state.producto.producto.marcaProducto
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "marcaProducto", value})
        }
      }
    }
  }
</script>

<style scoped>

</style>
